import {
  faClosedCaptioningSlash,
  faClosedCaptioning,
} from '@fortawesome/pro-regular-svg-icons';
import { useMediaRemote, useMediaStore } from '@vidstack/react';
import { useCallback } from 'react';
import { PlayerControlButton } from './base-button';
import { useVideoPlayerContext } from '../../player-context';

export const ClosedCaption = () => {
  const { playerRef } = useVideoPlayerContext();
  const mediaStore = useMediaStore(playerRef!);
  const textTrack = mediaStore?.textTrack;
  const isCaptionsEnabled = textTrack?.mode === 'showing';
  const remote = useMediaRemote(playerRef);
  const handleToggleCaptions = useCallback(() => {
    remote.changeTextTrackMode(0, isCaptionsEnabled ? 'hidden' : 'showing');
  }, [isCaptionsEnabled, remote]);

  return (
    <PlayerControlButton
      icon={isCaptionsEnabled ? faClosedCaptioning : faClosedCaptioningSlash}
      onClick={handleToggleCaptions}
    />
  );
};
